"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _default = typeof window !== 'undefined' && typeof window.document !== 'undefined';

exports["default"] = _default;
module.exports = exports.default;